module.exports = __webpack_public_path__ + "static/media/Logo_Bravecto_en.92aecde4.svg";